import { render } from "./SearchAuthorView.vue?vue&type=template&id=5f38aa7c&scoped=true"
import script from "./SearchAuthorView.vue?vue&type=script&lang=js"
export * from "./SearchAuthorView.vue?vue&type=script&lang=js"

import "./SearchAuthorView.vue?vue&type=style&index=0&id=5f38aa7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f38aa7c"]])

export default __exports__